import { get, post, del } from './client.js';

/**
 * 東訊 SDX500 授權管理 API（後端 /api/partner/sdx500/admin/*）
 * proxy 會把 Firebase token swap 成 RELAY_SHARED_SECRET + 帶 X-User-Uid，
 * 後端 requireTecomAdmin gate（@tecom.com / super_admin）。
 */
const BASE = '/api/partner/sdx500/admin';

function qs(params = {}) {
    const e = Object.entries(params).filter(([, v]) => v != null && v !== '');
    return e.length ? `?${e.map(([k, v]) => `${k}=${encodeURIComponent(v)}`).join('&')}` : '';
}

export const sdx500Api = {
    listLicenses: (params = {}) => get(`${BASE}/licenses${qs(params)}`),
    dealers: () => get(`${BASE}/dealers`),
    preRegister: (body) => post(`${BASE}/licenses`, body),
    suspend: (mac) => post(`${BASE}/licenses/${encodeURIComponent(mac)}/suspend`),
    // 修正預登錄席次（含已開通的 MAC）— provision 席次不符改為拒絕後，錯在預登錄那邊的唯一出路
    setExpectedLicenses: (mac, expectedLicenses) => post(`${BASE}/licenses/${encodeURIComponent(mac)}/expected-licenses`, { expectedLicenses }),
    // 刪除（僅後端允許 awaiting_provision / provisioned）
    remove: (mac) => del(`${BASE}/licenses/${encodeURIComponent(mac)}`),
    // 從東訊 SDX500 即時查授權（API-2 login → API-6 license/getinfo）
    licenseRefresh: (mac) => post(`${BASE}/licenses/${encodeURIComponent(mac)}/license-refresh`),
    // 測試東訊連線（API-2 login → API-3 get-sip-config，回 PBX+分機摘要；驗設備 API 帳號健康）
    sipConfigTest: (mac) => post(`${BASE}/licenses/${encodeURIComponent(mac)}/sip-config-test`),
    // 續約/升級/加購：上傳新 License.dat → 東訊 API-4 → API-6 回查 → 同步席次
    licenseUpdate: (mac, datFile) => post(`${BASE}/licenses/${encodeURIComponent(mac)}/license-update`, datFile),
    // 作廢一組授權（東訊 API-5，依 Id）。未到期需 force
    revokeLicense: (mac, licenseId, force = false) => post(`${BASE}/licenses/${encodeURIComponent(mac)}/revoke`, { licenseId, force }),
    // 設備更換 / 更換 MAC（換板 CCB）：把授權搬到新 MAC，帳號/租戶/角色/記錄全留
    migrateMac: (mac, newMac) => post(`${BASE}/licenses/${encodeURIComponent(mac)}/migrate-mac`, { newMac }),
    // End-user 遺失帳密：補發密碼重設連結 email 給客戶本人
    resendLogin: (mac) => post(`${BASE}/licenses/${encodeURIComponent(mac)}/resend-login`),
    // 超管「東訊大盤商」總覽：每家大盤商 + 客戶數/授權數
    distributorsOverview: () => get(`${BASE}/distributors-overview`),
    // license_admin 端：待處理的續約/加購申請
    listApplications: (status = 'pending') => get(`${BASE}/applications?status=${encodeURIComponent(status)}`),
    resolveApplication: (id, status, resolveNote = '') => post(`${BASE}/applications/${encodeURIComponent(id)}/resolve`, { status, resolveNote }),
};

// 客戶自助：我的授權 + 續約/加購申請（business 帳號本人）
const MY = '/api/partner/sdx500/my-license';
export const myLicenseApi = {
    get: () => get(MY),
    apply: (body) => post(`${MY}/apply`, body),
    refresh: () => post(`${MY}/refresh`, {}),   // 向設備讀最新授權並同步（60 秒一次）
};

// signup 連結 base（與後端 SDX500_SIGNUP_BASE 預設一致）
export const SIGNUP_BASE = 'https://ivr-admin.qubby.io/sdx500-signup';
